<template>
  <div class="signcontier">
    <el-form
      key="phoneform"
      :model="ruleForm"
      ref="ruleForm"
      :rules="rule"
      :label-width="this.$i18n.locale=='en'?'250px':'150px'"
      class="demo-ruleForm"
    >
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="this.$t('signphone.account')"
            prop="account"
          >
            <el-input
              v-model="ruleForm.account"
              :placeholder="$t('signphone.accountText')"
              class="inputsty"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('signphone.company')"
            prop="company"
          >
            <el-input
              v-model="ruleForm.company"
              :placeholder="$t('signphone.companyText')"
              class="inputsty"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('signphone.company_contact')"
            prop="company_contact"
          >
            <el-input
              v-model="ruleForm.company_contact"
              :placeholder="$t('signphone.company_contact_Text')"
              class="inputsty"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('signphone.password')"
            prop="passwords"
          >
            <el-input
              v-model="ruleForm.passwords"
              class="inputsty"
              type="password"
              v-popover:popovers
              :placeholder="$t('signphone.passwordText')"
            ></el-input>
            <el-popover
              ref="popovers"
              placement="right"
              width="30"
              trigger="focus"
              content=""
            >
            <p v-for="(item,im) in $t('signphone.popoversList')" :key="im">
              {{item.name}}
            </p>
            </el-popover>
          </el-form-item>
        </div>
      </div>
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('signphone.rePasswords')"
            prop="rePasswords"
          >
            <el-input
              v-model="ruleForm.rePasswords"
              class="inputsty"
              type="password"
              v-popover:popoversr
               :placeholder="$t('signphone.rePasswordsText')"
            ></el-input>
            <el-popover
              ref="popoversr"
              placement="right"
              width="30"
              trigger="focus"
              content=""
            >
              <p>{{$t('signphone.popoversr')}}</p>
            </el-popover>
          </el-form-item>
        </div>
      </div>
      <div class="content">
        <div class="formLeft">
          <el-form-item
           :label="$t('signphone.phone')"
            prop="phone"
          >
            <el-input
              v-model="ruleForm.phone"
              class="inputsty"
              :placeholder="$t('signphone.phoneText')"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div
        class="content posit"
        style="height:40px;"
      >
        <div class="formLeft">
          <drag-verify
            :width="316"
            :height="40"
            handlerIcon="el-icon-d-arrow-right"
            successIcon="el-icon-check"
            :text="$t('signphone.drag')"
            :success-text="$t('signphone.check')"
            background="#ddd"
            progress-bar-bg="#2ACBF8"
            text-size="14px"
            :circle="true"
            ref="Verify"
          >
          </drag-verify>
        </div>
      </div>
      <div
        style="color:red;"
        v-show="VerifyStatus"
      >{{$t('signphone.verifyStatus')}}</div>
      <div class="elbtn">
        <div
          class="titlecolor"
          style="margin-left:50px;cursor:pointer;"
        >
          <router-link
            target="_blank"
            :to="{ path: '/clause' }"
          ><span class="colorcur">{{$t('signphone.clause')}}</span></router-link>
          <span>&nbsp;&nbsp;&nbsp;</span>
          <router-link
            target="_blank"
            :to="{ path: '/privacy' }"
          ><span class="colorcur">{{$t('signphone.privacy')}}</span></router-link>
        </div>
        <div
          class="titlecolor"
          style="margin-top:5px;"
        >{{$t('signphone.care')}}</div>
        <el-button
          style="margin-top: 14px;width:316px;margin-left:50px;"
          @click="submite('ruleForm')"
          class="rightBtn"
          type="success"
          size="medium"
        >{{$t('signphone.agree')}}</el-button>
      </div>
    </el-form>

    <!-- 同意注册下一步 -->
    <el-dialog
      :visible.sync="changeDialogVisible"
       :width="this.$i18n.locale=='en'?'38%':'34%'"
      :title="$t('signphone.checkphone')"
      center
      class="diaglogs"
    >
      <div style="margin-bottom:30px;">
        {{$t('signphone.nextText')}}{{
        rephone.substr(0, 3) + "****" + rephone.substr(7)
        }}
      </div>
      <el-form
        :model="digruleForm"
        ref="digruleForm"
        :rules="digrule"
        :label-width="this.$i18n.locale=='en'?'220px':'150px'"
        class="demo-ruleForm"
      >
        <div class="content">
          <div
            class="formLeft"
            style="float:left;"
          >
            <el-form-item
              :label="$t('signphone.phonecode')"
              prop="code"
            >
              <el-input
                v-model="digruleForm.code"
                class="picwid"
                :placeholder="$t('signphone.codetext')"
              ></el-input>
              <div
                class="codewid"
                style="margin-left:15px;"
              >
                <el-button
                  type="success"
                  @click="phonesendCode"
                >{{
                  codeStr
                  }}</el-button>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="medium"
          type="success"
          @click="backlogin"
        >{{$t('signphone.submit')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dragVerify from "vue-drag-verify";
export default {
  components: {
    dragVerify
  },
  props: {},
  data() {
    var loginaccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('checkvalid.account')));
      }else {
        callback();
      }
    };
    var loginPass = (rule, value, callback) => {
      var rest = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,}$/;
      if (
        !rest.test(value) ||
        !value ||
        value.length < 6 ||
        value.length > 20
      ) {
        return callback(new Error(this.$t('checkvalid.password')));
      } else {
        callback();
      }
    };
    var rePass = (rule, value, callback) => {
      var rest = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,}$/;
      if (
        !rest.test(value) ||
        !value ||
        value.length < 6 ||
        value.length > 20
      ) {
        return callback(new Error(this.$t('checkvalid.password')));
      } else if (value !== this.ruleForm.passwords) {
        callback(new Error(this.$t('checkvalid.same')));
      } else {
        callback();
      }
    };
    var phonevalid = (rule, value, callback) => {
      var rest = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!rest.test(value) || value == 0) {
        return callback(new Error(this.$t('checkvalid.phone')));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        account: "",
        company: "",
        passwords: "",
        rePasswords: "",
        phone: "", //本人绑定手机号
        code: "",
        company_contact: ""
      },
      rule: {
        account: [{ required: true, validator: loginaccount, trigger: "blur" }],
        company: [
          { required: true, message: this.$t('checkvalid.company'), trigger: "blur" }
        ],
        company_contact: [
          { required: true, message: this.$t('checkvalid.contact'), trigger: "blur" }
        ],
        passwords: [{ required: true, validator: loginPass, trigger: "blur" }],
        phone: [{ required: true, validator: phonevalid, trigger: "blur" }],
        rePasswords: [{ required: true, validator: rePass, trigger: "blur" }]
      },
      changeDialogVisible: false,
      digruleForm: {
        code: ""
      },
      rephone: "",
      digrule: {
        code: [{ required: true, message: this.$t('checkvalid.code'), trigger: "blur" }]
      },
      codeStr: this.$t('forgectPhone.codeStr'),
      xyDialogVisible: false,
      cursor: true,
      VerifyStatus: false
    };
  },
  methods: {
    rulesp() {
      this.$refs["ruleForm"].clearValidate();
    },
    phonesendCode() {
      let that = this;
      let times = 60;
      // this.codeBinds();
      const data = {
        phone: this.rephone
      };
      this.$http
        .post("/common/get_phone_code", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t('checkvalid.codesuccess'),
                type: "success",
                duration: 1500
              });
              let timer = setInterval(() => {
                --times;
                that.codeStr = times + "S";
                if (times == 0) {
                  this.codeStr = this.$t('forgectPhone.codeStr');
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    codeBinds() {
      const data = {
        phone: this.rephone
      };
      this.$http
        .post("/common/get_phone_code", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t('forgectPhone.codesuccess'),
                type: "success",
                duration: 1500
              });
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    submite(ruleForm) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (!this.$refs.Verify.isPassing) {
            this.VerifyStatus = true;
            return false;
          } else {
            this.VerifyStatus = false;
          }
          this.changeDialogVisible = true;
          this.rephone = this.ruleForm.phone;
        } else {
          console.log("error submit!!");
        }
      });
    },
    userInfo() {
      const data = {
        token: this.$store.state.token
      };
      this.$http
        .post("/user/get_me", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              // 先进行本地存储
              console.log(res.data);
              this.$store.state.userName = res.data.data.name;
              window.sessionStorage.setItem("userName", res.data.data.name);
              this.$router.push({
                name: "main"
              });
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    backlogin() {
      this.changeDialogVisible = false;
      const data = {
        name: this.ruleForm.account,
        company_name: this.ruleForm.company,
        password: this.ruleForm.passwords,
        phone: this.rephone,
        code: this.digruleForm.code,
        company_contact: this.ruleForm.company_contact
      };
      this.$http
        .post("/login/phone_register", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              console.log(res.data);
              // this.$store.commit(loginIn, res.data.data.token);
              this.$store.state.token = res.data.data.token;
              window.sessionStorage.setItem("token", res.data.data.token);
              this.$message({
                message: this.$t('checkvalid.logins'),
                type: "success",
                duration: 1500
              });
              this.userInfo();
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss">
.signcontier {
  .codes {
    text-align: center;
    font-size: 16px;
  }
  .codeImg {
    margin-top: 30px;
    text-align: center;
    img {
      width: 190px;
      height: 75px;
    }
  }
  .codesy {
    color: #26a2ff;
    text-align: center;
    position: absolute;
    left: 125px;
    font-size: 13px;
    width: 69px;
  }
  .kbq {
    font-size: 15px;
    margin-top: 20px;
    text-align: center;
    margin-bottom: 10px;
  }
  .codewid {
    display: inline-block;
    img {
      width: 100%;
    }
  }
  .el-steps--horizontal {
    padding: 0 40px;
    margin-top: 20px;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .diaglogs {
    .el-form-item__label {
      padding-right: 24px;
    }
  }
}
</style>
